import React from "react";

// Client BIR branch code (docs/WHT_IMPLEMENTATION.md D4) — accounting firms
// only; shared by the new-client and edit-client pages.

// Mirrors AccountingClient.branchCode: 4 or 5 digits.
export const BRANCH_CODE_RE = /^\d{4,5}$/;
export const BRANCH_CODE_ERROR = "Branch code must be 4 or 5 digits (e.g. 0000 or 00000 for head office)";
export const isValidBranchCode = (v) => BRANCH_CODE_RE.test(String(v ?? "").trim());

const BranchCodeField = ({ value, onChange, disabled = false, id = "client-branch-code" }) => (
  <div>
    <label htmlFor={id} className="block text-sm font-medium text-ink mb-2">
      Branch code
    </label>
    <input
      id={id}
      type="text"
      inputMode="numeric"
      maxLength={5}
      value={value}
      onChange={(e) => onChange(e.target.value.replace(/\D/g, ""))}
      className="w-full border border-ink-line rounded-md px-3 py-2 text-sm text-ink bg-white focus:outline-none focus:ring-2 focus:ring-primary-500"
      placeholder="0000"
      disabled={disabled}
    />
    <p className="text-xs text-ink-body mt-1">
      4 or 5 digits from the BIR registration; head office is 0000. Shown as 5 digits on forms.
    </p>
  </div>
);

export default BranchCodeField;
